module.exports = __webpack_public_path__ + "static/media/Pixel Colours - Rational Mood.0e87c700.otf";